import { FEATURE_AUTH_FRONTEND_CUTOVER } from './constants';
import { getUnleashClient } from './unleashClient';

/**
 * Returns true only when the `feature.auth.frontend-cutover` Unleash flag is
 * explicitly enabled for the current client. Used at the SPA's non-React
 * entry points (axios 401 redirect, class-component Logout) to route users to
 * the new auth slice (`/auth/login`) instead of the legacy SPA `/login` page.
 *
 * Returns false on any error (no client yet, proxy unreachable, etc.) so
 * the rollout is fail-closed: clients only see the new slice when the proxy
 * explicitly confirms membership. Mirrors the pattern in
 * `isSafeRedirectEnabled` (DEV-20732).
 *
 * TODO DEV-21196: remove once the cutover is complete and all callers hardcode '/auth/login'.
 */
export const isAuthFrontendCutoverEnabled = (): boolean => {
  try {
    return getUnleashClient().isEnabled(FEATURE_AUTH_FRONTEND_CUTOVER);
  } catch {
    return false;
  }
};
